// extracted by mini-css-extract-plugin
module.exports = {"table":"SimpleAttributes_table__606fc","valueColumn":"SimpleAttributes_valueColumn__b942f"};